(function(){
  function findPicker(el){
    var scope = (el && el.closest) ? (el.closest('.shopify-section') || document) : document;
    return scope.querySelector('variant-picker') || document.querySelector('variant-picker[data-template-product-match="true"]') || document.querySelector('variant-picker');
  }
  function setOption(picker, index, val){
    var fieldsets = picker.querySelectorAll('.variant-option--buttons');
    var selects = picker.querySelectorAll('select.variant-option__select');
    if(fieldsets[index]){
      var radios = fieldsets[index].querySelectorAll('input[type=radio]');
      for(var r=0;r<radios.length;r++){ if(radios[r].value === val){ if(!radios[r].checked){ radios[r].checked = true; } return radios[r]; } }
    }
    if(selects[index]){ if(selects[index].value !== val){ selects[index].value = val; } return selects[index]; }
    return null;
  }
  function onPick(el){
    if(el.classList.contains('is-soldout')) return;
    var picker = findPicker(el); if(!picker) return;
    var changed = [];
    if(el.hasAttribute('data-options')){
      var opts = el.getAttribute('data-options').split('~|~');
      for(var i=0;i<opts.length;i++){ var c = setOption(picker, i, opts[i]); if(c) changed.push(c); }
    } else if(el.hasAttribute('data-opt-value')){
      var idx = parseInt(el.getAttribute('data-opt-index')||'0', 10);
      var val = el.getAttribute('data-opt-value');
      // SPARSE MATRIX: not every option combination exists as a real variant
      // (e.g. Storlek 2 x Antal 3 = 6 combos but only 3 variants). If the combo
      // formed by {this value + the current other options} does not exist, jump to
      // the closest AVAILABLE variant that has this value and set ALL its options —
      // exactly what the native picker does — instead of leaving a dead selection.
      var curVals = readVals(picker);
      var cand = curVals.slice(); cand[idx] = val;
      var target = variantFor(cand);
      if(!target){ target = bestVariantWith(idx, val, curVals); }
      if(target && target.options && target.options.length > 1){
        for(var t=0;t<target.options.length;t++){
          var ct = setOption(picker, t, target.options[t]); if(ct) changed.push(ct);
        }
      } else {
        var cc = setOption(picker, idx, val); if(cc) changed.push(cc);
      }
    } else { return; }
    for(var d=0;d<changed.length;d++){ changed[d].dispatchEvent(new Event('change', {bubbles:true})); }
    var group = el.closest('.dj-vc__rail, .dj-vp__pills');
    if(group){ var sel = group.querySelectorAll('.is-selected'); for(var s=0;s<sel.length;s++){ sel[s].classList.remove('is-selected'); } }
    el.classList.add('is-selected');
    var host = el.closest('dj-variant-cards') || el.closest('.dj-vp__opt');
    if(host){ var lbl = host.querySelector('[data-dj-vc-selected], .dj-vp__opt-sel'); var nm = el.querySelector('.dj-vc__name'); var txt = nm ? nm.textContent.trim() : el.textContent.trim(); if(lbl){ lbl.textContent = txt; } }
    scheduleSync();
  }
  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    var arrow = e.target.closest('.dj-vc__arrow');
    if(arrow){
      var sc = arrow.closest('.dj-vc__scroll');
      var rail = sc ? sc.querySelector('.dj-vc__rail') : null;
      if(rail){
        var dir = arrow.classList.contains('dj-vc__arrow--left') ? -1 : 1;
        var max = rail.scrollWidth - rail.clientWidth;
        var cards = rail.querySelectorAll('.dj-vc__card');
        var target;
        if(cards.length > 1){
          // step = distance between two card starts (card width + gap)
          var step = cards[1].offsetLeft - cards[0].offsetLeft;
          if(step < 1){ step = cards[0].getBoundingClientRect().width; }
          // move a whole page of WHOLE cards (at least one)
          var perView = Math.max(1, Math.floor(rail.clientWidth / step));
          // snap the resulting position to a card boundary so it never lands
          // mid-gap or past the last card (which showed empty space)
          var idx = Math.round(rail.scrollLeft / step) + dir * perView;
          target = idx * step;
        } else {
          target = rail.scrollLeft + dir * Math.round(rail.clientWidth * 0.7);
        }
        if(target < 0){ target = 0; }
        if(target > max){ target = max; }
        if(rail.scrollTo){ rail.scrollTo({left: target, behavior:'smooth'}); }
        else { rail.scrollLeft = target; }
      }
      return;
    }
    var el = e.target.closest('.dj-vc__card, .dj-vp__pill');
    if(el){ onPick(el); return; }
  });

  var PRODUCT = null;
  function loadProduct(){
    var path = location.pathname.replace(/\/$/, '');
    if(path.indexOf('/products/') === -1) return;
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(p){ PRODUCT = p; refreshAvail(); })
      .catch(function(){});
  }
  function variantFor(candidate){
    if(!PRODUCT || !PRODUCT.variants) return null;
    for(var i=0;i<PRODUCT.variants.length;i++){
      var v = PRODUCT.variants[i]; var ok = true;
      for(var k=0;k<candidate.length;k++){ if(candidate[k] != null && String(v.options[k]) !== String(candidate[k])){ ok = false; break; } }
      if(ok) return v;
    }
    return null;
  }
  // Closest AVAILABLE variant that carries this option value, preferring the one
  // that keeps the most of the customer's other current selections.
  function bestVariantWith(idx, value, vals){
    if(!PRODUCT || !PRODUCT.variants) return null;
    var best = null, bestScore = -1;
    for(var i=0;i<PRODUCT.variants.length;i++){
      var v = PRODUCT.variants[i];
      if(!v.options || String(v.options[idx]) !== String(value)) continue;
      if(v.available === false) continue;
      var score = 0;
      for(var k=0;k<v.options.length;k++){
        if(k !== idx && vals[k] != null && String(v.options[k]) === String(vals[k])) score++;
      }
      if(score > bestScore){ bestScore = score; best = v; }
    }
    return best;
  }
  function refreshAvail(){
    if(!PRODUCT || !PRODUCT.variants) return;
    var picker = document.querySelector('variant-picker'); if(!picker) return;
    var vals = readVals(picker); if(!vals.length) return;
    var els = document.querySelectorAll('[data-opt-value]');
    for(var i=0;i<els.length;i++){
      var el = els[i];
      var idx = parseInt(el.getAttribute('data-opt-index')||'0',10);
      var val = el.getAttribute('data-opt-value');
      var cand = vals.slice(); cand[idx] = val;
      var strict = variantFor(cand);
      var soldout;
      if(strict){
        // The combination EXISTS -> keep the true per-combination sold-out signal
        // (picking Rosa strikes the sizes that are out of stock in Rosa).
        soldout = (strict.available === false);
      } else {
        // The combination is NOT offered at all (sparse matrix). Only strike the
        // value if NO available variant anywhere carries it — otherwise it stays
        // selectable and onPick jumps to the closest available variant.
        soldout = !bestVariantWith(idx, val, vals);
      }
      el.classList.toggle('is-soldout', soldout);
      // CORRECT CARD IMAGE: Liquid can only use val.variant (the FIRST variant that
      // carries this value), which ignores what the customer picked for the OTHER
      // options — so cards showed unrelated photos. Swap in the image of the variant
      // that actually applies to {this value + current other options}.
      setCardImage(el, strict || bestVariantWith(idx, val, vals));
    }
  }
  function imgSized(src){
    if(!src) return '';
    if(src.indexOf('//') === 0){ src = 'https:' + src; }
    if(/[?&]width=|_\d+x\d*\./i.test(src)) return src;
    return src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_240x$1$2');
  }
  function setCardImage(el, variant){
    if(!el.classList.contains('dj-vc__card')) return;
    var img = el.querySelector('.dj-vc__imgwrap img'); if(!img) return;
    var src = variant && variant.featured_image && variant.featured_image.src;
    if(!src && PRODUCT && PRODUCT.featured_image){ src = PRODUCT.featured_image; }
    src = imgSized(src);
    if(src && img.getAttribute('src') !== src){ img.setAttribute('src', src); }
  }

  function readVals(picker){
    var controls = picker.querySelectorAll('select.variant-option__select, fieldset.variant-option--buttons, .variant-option--buttons');
    var seen = [], vals = [];
    for(var i=0;i<controls.length;i++){
      var c = controls[i];
      if(seen.indexOf(c) !== -1) continue; seen.push(c);
      if(c.tagName === 'SELECT'){ vals.push(c.value); }
      else { var ch = c.querySelector('input:checked'); vals.push(ch ? ch.value : null); }
    }
    return vals;
  }
  function setGroupSelected(el, on){ el.classList.toggle('is-selected', !!on); }
  function syncAll(){
    var picker = document.querySelector('variant-picker'); if(!picker) return;
    var vals = readVals(picker); if(!vals.length) return;
    var i, list;
    list = document.querySelectorAll('.dj-vc__card[data-options]');
    for(i=0;i<list.length;i++){
      var opts = list[i].getAttribute('data-options').split('~|~');
      var match = true;
      for(var o=0;o<opts.length;o++){ if(vals[o] != null && opts[o] !== vals[o]){ match = false; break; } }
      setGroupSelected(list[i], match);
    }
    list = document.querySelectorAll('[data-opt-value]');
    for(i=0;i<list.length;i++){
      var idx = parseInt(list[i].getAttribute('data-opt-index')||'0',10);
      setGroupSelected(list[i], vals[idx] === list[i].getAttribute('data-opt-value'));
    }
    var hosts = document.querySelectorAll('dj-variant-cards');
    for(i=0;i<hosts.length;i++){
      var hidx = parseInt(hosts[i].getAttribute('data-opt-index')||'0',10);
      var hl = hosts[i].querySelector('[data-dj-vc-selected]');
      if(hl){ hl.textContent = hosts[i].querySelector('.dj-vc__card[data-options]') ? vals.join(' / ') : (vals[hidx]||''); }
    }
    var optsWrap = document.querySelectorAll('.dj-vp__opt');
    for(i=0;i<optsWrap.length;i++){
      var pill = optsWrap[i].querySelector('.dj-vp__pill[data-opt-index]');
      var pidx = pill ? parseInt(pill.getAttribute('data-opt-index')||'0',10) : 0;
      var sl = optsWrap[i].querySelector('.dj-vp__opt-sel');
      if(sl){ sl.textContent = vals[pidx]||''; }
    }
    refreshAvail();
  }
  function scheduleSync(){ setTimeout(syncAll, 0); setTimeout(syncAll, 200); setTimeout(syncAll, 500); }
  document.addEventListener('change', function(e){
    var t = e.target; if(!t) return;
    var inPicker = t.closest && t.closest('variant-picker');
    var isSticky = t.classList && t.classList.contains('dj-sticky-variant');
    if(inPicker || isSticky){ scheduleSync(); }
  }, true);
  ['variant:update','variantchange','on:variant:change','variant:change'].forEach(function(ev){ document.addEventListener(ev, scheduleSync, true); });

  function updArrows(){
    var hosts = document.querySelectorAll('.dj-vc');
    for(var i=0;i<hosts.length;i++){
      var rail = hosts[i].querySelector('.dj-vc__rail'); if(!rail) continue;
      var noscroll = rail.scrollWidth <= rail.clientWidth + 2;
      var atStart = rail.scrollLeft <= 4;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      hosts[i].classList.toggle('dj-vc--noscroll', noscroll);
      hosts[i].classList.toggle('dj-vc--start', atStart);
      hosts[i].classList.toggle('dj-vc--end', atEnd);
    }
  }
  // Reveal the pre-selected (deep-linked ?variant=) card in the horizontal rail.
  // Runs ONLY on initial load so a variant hidden to the right is centred and
  // visible from the start, without the customer having to swipe. Instant (no
  // animation) so the rail is simply pre-positioned when the page opens.
  function revealSelected(smooth){
    var rails = document.querySelectorAll('.dj-vc__rail');
    for(var i=0;i<rails.length;i++){
      var rail = rails[i];
      if(!rail || rail.scrollWidth <= rail.clientWidth + 2) continue;
      var card = rail.querySelector('.dj-vc__card.is-selected');
      if(!card) continue;
      var railRect = rail.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var pad = 10;
      if(cardRect.left < railRect.left + pad || cardRect.right > railRect.right - pad){
        var delta = (cardRect.left - railRect.left) - (rail.clientWidth - card.clientWidth) / 2;
        var target = rail.scrollLeft + delta;
        var max = rail.scrollWidth - rail.clientWidth;
        if(target < 0){ target = 0; }
        if(target > max){ target = max; }
        if(smooth && rail.scrollTo){ rail.scrollTo({left: target, behavior: 'smooth'}); }
        else { rail.scrollLeft = target; }
      }
    }
    updArrows();
  }
  var didReveal = false;
  function initialReveal(){
    try{ syncAll(); revealSelected(false); }catch(e){}
    didReveal = true;
  }
  document.addEventListener('scroll', function(e){ if(e.target && e.target.classList && e.target.classList.contains('dj-vc__rail')) updArrows(); }, true);
  window.addEventListener('resize', updArrows);
  var n=0, iv=setInterval(function(){ updArrows(); if(++n>25){ clearInterval(iv); } }, 400);
  function init(){
    updArrows(); syncAll(); loadProduct();
    // Pre-position the rail on the selected variant, retried a few times to
    // survive the native picker's async re-render on deep-linked loads.
    initialReveal();
    setTimeout(initialReveal, 150);
    setTimeout(initialReveal, 450);
    setTimeout(function(){ try{ revealSelected(false); }catch(e){} }, 900);
  }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
